"use client";

import { useTranslations } from "next-intl";
import { FaExclamationTriangle } from "react-icons/fa";
import { twMerge } from "tailwind-merge";

import { useStatus } from "../hooks/useStatus";

import { Button } from "./tailwind/Button";

export const GLOBAL_ALERT_HEIGHT = 64;

export const GlobalAlert = (): JSX.Element => {
  const t = useTranslations("GlobalAlert");
  const { status } = useStatus();

  return (
    <div
      className={twMerge(
        "h-16 w-screen transition-all duration-700",
        status ? "h-16 opacity-1" : "h-0 opacity-0"
      )}
    >
      {!!status && (
        <div className="h-16 p-4 w-screen border-b border-b-yellow-500 bg-blue-950 flex justify-center items-center p-2 gap-3 fixed z-[1000]">
          <span className="text-yellow-500 text-xl">
            <FaExclamationTriangle />
          </span>
          {status.title && (
            <span className="font-bold text-base leading-4">
              {status.title}
            </span>
          )}
          {status.description && <span>{status.description}</span>}
          {status.link && (
            <Button
              variant="flat"
              color="secondary"
              ariaLabel={t("more_info")}
              href={status.link}
              target="_blank"
            >
              {t("more_info")}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};
